import pathfinder from '@fiverr-private/pathfinder';
import { formatQueryParams, getCategorySlug, getNestedSubCategorySlug, getSubCategorySlug } from '../helperFunctions';
import { PATHFINDER, PATHS } from '../constants';
import type { MapperItemConfig } from './types';

export const getNestedSubCategoryPath = ({
    categoryId,
    id,
    nestedSubCategoryId,
    filter,
    queryParams,
    source,
}: MapperItemConfig) => {
    if (!(categoryId && id && nestedSubCategoryId)) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(categoryId, 10)) || isNaN(parseInt(id, 10)) || isNaN(parseInt(nestedSubCategoryId, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getCategorySlug(categoryId);
    const subCategorySlug = getSubCategorySlug(id);
    const nestedSubCategorySlug = getNestedSubCategorySlug(nestedSubCategoryId, id);

    const params = {
        category_id: categorySlug,
        id: subCategorySlug,
        nested_sub_category_id: nestedSubCategorySlug,
    };

    return pathfinder(PATHFINDER.NESTED_SUB_CATEGORY, params, formatQueryParams({ filter, queryParams, source }));
};
